/**
 * Lista de comunas de Chile para selector en formularios
 * Datos extraídos de la tabla public."Communes" de la base de datos
 *
 * @description Se hardcodean aquí ya que las comunas de Chile no cambian frecuentemente
 */

export const COMUNAS_CHILE = [
  { id: 2, name: "ALGARROBO", regionId: 5 },
  { id: 4, name: "ALTO BIO BIO", regionId: 8 },
  { id: 5, name: "ALTO DEL CARMEN", regionId: 3 },
  { id: 6, name: "ALTO HOSPICIO", regionId: 1 },
  { id: 8, name: "ANCUD", regionId: 10 },
  { id: 9, name: "ANDACOLLO", regionId: 4 },
  { id: 10, name: "ANGOL", regionId: 9 },
  { id: 11, name: "ANTARTICA", regionId: 12 },
  { id: 12, name: "ANTOFAGASTA", regionId: 2 },
  { id: 13, name: "ANTUCO", regionId: 8 },
  { id: 14, name: "ARAUCO", regionId: 8 },
  { id: 15, name: "ARICA", regionId: 15 },
  { id: 16, name: "AYSEN", regionId: 11 },
  { id: 18, name: "BUIN", regionId: 13 },
  { id: 19, name: "BULNES", regionId: 16 },
  { id: 20, name: "CABILDO", regionId: 5 },
  { id: 21, name: "CABRERO", regionId: 8 },
  { id: 22, name: "CALAMA", regionId: 2 },
  { id: 23, name: "CALBUCO", regionId: 10 },
  { id: 24, name: "CALDERA", regionId: 3 },
  { id: 25, name: "CALERA", regionId: 5 },
  { id: 26, name: "CALERA DE TANGO", regionId: 13 },
  { id: 27, name: "CALLE LARGA", regionId: 5 },
  { id: 28, name: "CAMARONES", regionId: 15 },
  { id: 29, name: "CAMINA", regionId: 1 },
  { id: 30, name: "CANELA", regionId: 4 },
  { id: 31, name: "CANETE", regionId: 8 },
  { id: 32, name: "CARAHUE", regionId: 9 },
  { id: 33, name: "CARTAGENA", regionId: 5 },
  { id: 34, name: "CASABLANCA", regionId: 5 },
  { id: 35, name: "CASTRO", regionId: 10 },
  { id: 36, name: "CATEMU", regionId: 5 },
  { id: 37, name: "CAUQUENES", regionId: 7 },
  { id: 38, name: "CERRILLOS", regionId: 13 },
  { id: 39, name: "CERRO NAVIA", regionId: 13 },
  { id: 40, name: "CHAITEN", regionId: 10 },
  { id: 41, name: "CHANARAL", regionId: 3 },
  { id: 42, name: "CHANCO", regionId: 7 },
  { id: 43, name: "CHEPICA", regionId: 6 },
  { id: 44, name: "CHIGUAYANTE", regionId: 8 },
  { id: 45, name: "CHILE CHICO", regionId: 11 },
  { id: 46, name: "CHILLAN", regionId: 16 },
  { id: 47, name: "CHILLAN VIEJO", regionId: 16 },
  { id: 48, name: "CHIMBARONGO", regionId: 6 },
  { id: 49, name: "CHOLCHOL", regionId: 9 },
  { id: 50, name: "CHONCHI", regionId: 10 },
  { id: 51, name: "CISNES", regionId: 11 },
  { id: 52, name: "COBQUECURA", regionId: 16 },
  { id: 53, name: "COCHAMO", regionId: 10 },
  { id: 54, name: "COCHRANE", regionId: 11 },
  { id: 55, name: "CODEGUA", regionId: 6 },
  { id: 56, name: "COELEMU", regionId: 16 },
  { id: 57, name: "COIHAIQUE", regionId: 11 },
  { id: 58, name: "COIHUECO", regionId: 16 },
  { id: 59, name: "COINCO", regionId: 6 },
  { id: 60, name: "COLBUN", regionId: 7 },
  { id: 61, name: "COLCHANE", regionId: 1 },
  { id: 62, name: "COLINA", regionId: 13 },
  { id: 63, name: "COLLIPULLI", regionId: 9 },
  { id: 64, name: "COLTAUCO", regionId: 6 },
  { id: 65, name: "COMBARBALA", regionId: 4 },
  { id: 66, name: "CONCEPCION", regionId: 8 },
  { id: 67, name: "CONCHALI", regionId: 13 },
  { id: 68, name: "CONCON", regionId: 5 },
  { id: 69, name: "CONSTITUCION", regionId: 7 },
  { id: 70, name: "CONTULMO", regionId: 8 },
  { id: 71, name: "COPIAPO", regionId: 3 },
  { id: 72, name: "COQUIMBO", regionId: 4 },
  { id: 73, name: "CORONEL", regionId: 8 },
  { id: 74, name: "CORRAL", regionId: 14 },
  { id: 75, name: "CUNCO", regionId: 9 },
  { id: 76, name: "CURACAUTIN", regionId: 9 },
  { id: 77, name: "CURACAVI", regionId: 13 },
  { id: 78, name: "CURACO DE VELEZ", regionId: 10 },
  { id: 79, name: "CURANILAHUE", regionId: 8 },
  { id: 80, name: "CURARREHUE", regionId: 9 },
  { id: 81, name: "CUREPTO", regionId: 7 },
  { id: 82, name: "CURICO", regionId: 7 },
  { id: 83, name: "DALCAHUE", regionId: 10 },
  { id: 84, name: "DIEGO DE ALMAGRO", regionId: 3 },
  { id: 85, name: "DONIHUE", regionId: 6 },
  { id: 86, name: "EL BOSQUE", regionId: 13 },
  { id: 87, name: "EL CARMEN", regionId: 16 },
  { id: 88, name: "EL MONTE", regionId: 13 },
  { id: 89, name: "EL QUISCO", regionId: 5 },
  { id: 90, name: "EL TABO", regionId: 5 },
  { id: 91, name: "EMPEDRADO", regionId: 7 },
  { id: 92, name: "ERCILLA", regionId: 9 },
  { id: 93, name: "ESTACION CENTRAL", regionId: 13 },
  { id: 94, name: "FLORIDA", regionId: 8 },
  { id: 95, name: "FREIRE", regionId: 9 },
  { id: 96, name: "FREIRINA", regionId: 3 },
  { id: 97, name: "FRESIA", regionId: 10 },
  { id: 98, name: "FRUTILLAR", regionId: 10 },
  { id: 99, name: "FUTALEUFU", regionId: 10 },
  { id: 100, name: "FUTRONO", regionId: 14 },
  { id: 101, name: "GALVARINO", regionId: 9 },
  { id: 102, name: "GENERAL LAGOS", regionId: 15 },
  { id: 103, name: "GORBEA", regionId: 9 },
  { id: 104, name: "GRANEROS", regionId: 6 },
  { id: 105, name: "GUAITECAS", regionId: 11 },
  { id: 106, name: "HIJUELAS", regionId: 5 },
  { id: 107, name: "HUALANE", regionId: 7 },
  { id: 108, name: "HUALPEN", regionId: 8 },
  { id: 109, name: "HUALQUI", regionId: 8 },
  { id: 110, name: "HUARA", regionId: 1 },
  { id: 111, name: "HUASCO", regionId: 3 },
  { id: 112, name: "HUECHURABA", regionId: 13 },
  { id: 113, name: "ILLAPEL", regionId: 4 },
  { id: 114, name: "INDEPENDENCIA", regionId: 13 },
  { id: 115, name: "IQUIQUE", regionId: 1 },
  { id: 116, name: "ISLA DE MAIPO", regionId: 13 },
  { id: 117, name: "ISLA DE PASCUA", regionId: 5 },
  { id: 118, name: "JUAN FERNANDEZ", regionId: 5 },
  { id: 119, name: "LA CALERA", regionId: 5 },
  { id: 120, name: "LA CISTERNA", regionId: 13 },
  { id: 121, name: "LA CRUZ", regionId: 5 },
  { id: 122, name: "LA ESTRELLA", regionId: 6 },
  { id: 123, name: "LA FLORIDA", regionId: 13 },
  { id: 124, name: "LA GRANJA", regionId: 13 },
  { id: 125, name: "LA HIGUERA", regionId: 4 },
  { id: 126, name: "LA LIGUA", regionId: 5 },
  { id: 127, name: "LA PINTANA", regionId: 13 },
  { id: 128, name: "LA REINA", regionId: 13 },
  { id: 129, name: "LA SERENA", regionId: 4 },
  { id: 130, name: "LA UNION", regionId: 14 },
  { id: 131, name: "LAGO RANCO", regionId: 14 },
  { id: 132, name: "LAGO VERDE", regionId: 11 },
  { id: 133, name: "LAGUNA BLANCA", regionId: 12 },
  { id: 134, name: "LAJA", regionId: 8 },
  { id: 135, name: "LAMPA", regionId: 13 },
  { id: 136, name: "LANCO", regionId: 14 },
  { id: 137, name: "LAS CABRAS", regionId: 6 },
  { id: 138, name: "LAS CONDES", regionId: 13 },
  { id: 139, name: "LAUTARO", regionId: 9 },
  { id: 140, name: "LEBU", regionId: 8 },
  { id: 141, name: "LICANTEN", regionId: 7 },
  { id: 142, name: "LIMACHE", regionId: 5 },
  { id: 143, name: "LINARES", regionId: 7 },
  { id: 144, name: "LITUECHE", regionId: 6 },
  { id: 145, name: "LLANQUIHUE", regionId: 10 },
  { id: 146, name: "LLAILLAY", regionId: 5 },
  { id: 147, name: "LO BARNECHEA", regionId: 13 },
  { id: 148, name: "LO ESPEJO", regionId: 13 },
  { id: 149, name: "LO PRADO", regionId: 13 },
  { id: 150, name: "LOLOL", regionId: 6 },
  { id: 151, name: "LONCOCHE", regionId: 9 },
  { id: 152, name: "LONGAVI", regionId: 7 },
  { id: 153, name: "LONQUIMAY", regionId: 9 },
  { id: 154, name: "LOS ALAMOS", regionId: 8 },
  { id: 155, name: "LOS ANDES", regionId: 5 },
  { id: 156, name: "LOS ANGELES", regionId: 8 },
  { id: 157, name: "LOS LAGOS", regionId: 14 },
  { id: 158, name: "LOS MUERMOS", regionId: 10 },
  { id: 159, name: "LOS SAUCES", regionId: 9 },
  { id: 160, name: "LOS VILOS", regionId: 4 },
  { id: 161, name: "LOTA", regionId: 8 },
  { id: 162, name: "LUMACO", regionId: 9 },
  { id: 163, name: "MACHALI", regionId: 6 },
  { id: 164, name: "MACUL", regionId: 13 },
  { id: 165, name: "MAFIL", regionId: 14 },
  { id: 166, name: "MAIPU", regionId: 13 },
  { id: 167, name: "MALLOA", regionId: 6 },
  { id: 168, name: "MARCHIGUE", regionId: 6 },
  { id: 169, name: "MARIA ELENA", regionId: 2 },
  { id: 170, name: "MARIA PINTO", regionId: 13 },
  { id: 171, name: "MARIQUINA", regionId: 14 },
  { id: 172, name: "MAULE", regionId: 7 },
  { id: 173, name: "MAULLIN", regionId: 10 },
  { id: 174, name: "MEJILLONES", regionId: 2 },
  { id: 175, name: "MELIPEUCO", regionId: 9 },
  { id: 176, name: "MELIPILLA", regionId: 13 },
  { id: 177, name: "MOLINA", regionId: 7 },
  { id: 178, name: "MONTE PATRIA", regionId: 4 },
  { id: 179, name: "MOSTAZAL", regionId: 6 },
  { id: 180, name: "MULCHEN", regionId: 8 },
  { id: 181, name: "NACIMIENTO", regionId: 8 },
  { id: 182, name: "NANCAGUA", regionId: 6 },
  { id: 183, name: "NATALES", regionId: 12 },
  { id: 184, name: "NAVIDAD", regionId: 6 },
  { id: 185, name: "NEGRETE", regionId: 8 },
  { id: 186, name: "NINHUE", regionId: 16 },
  { id: 187, name: "NIQUEN", regionId: 16 },
  { id: 188, name: "NOGALES", regionId: 5 },
  { id: 189, name: "NUEVA IMPERIAL", regionId: 9 },
  { id: 190, name: "NUNOA", regionId: 13 },
  { id: 191, name: "O'HIGGINS", regionId: 11 },
  { id: 192, name: "OHIGGINS", regionId: 11 },
  { id: 193, name: "OLIVAR", regionId: 6 },
  { id: 194, name: "OLLAGUE", regionId: 2 },
  { id: 195, name: "OLMUE", regionId: 5 },
  { id: 196, name: "OSORNO", regionId: 10 },
  { id: 197, name: "OVALLE", regionId: 4 },
  { id: 198, name: "PADRE HURTADO", regionId: 13 },
  { id: 199, name: "PADRE LAS CASAS", regionId: 9 },
  { id: 200, name: "PAIHUANO", regionId: 4 },
  { id: 201, name: "PAILLACO", regionId: 14 },
  { id: 202, name: "PAINE", regionId: 13 },
  { id: 203, name: "PALENA", regionId: 10 },
  { id: 204, name: "PALMILLA", regionId: 6 },
  { id: 205, name: "PANGUIPULLI", regionId: 14 },
  { id: 206, name: "PANQUEHUE", regionId: 5 },
  { id: 207, name: "PAPUDO", regionId: 5 },
  { id: 208, name: "PAREDONES", regionId: 6 },
  { id: 209, name: "PARRAL", regionId: 7 },
  { id: 210, name: "PEDRO AGUIRRE CERDA", regionId: 13 },
  { id: 211, name: "PELARCO", regionId: 7 },
  { id: 212, name: "PELLUHUE", regionId: 7 },
  { id: 213, name: "PEMUCO", regionId: 16 },
  { id: 214, name: "PENAFLOR", regionId: 13 },
  { id: 215, name: "PENALOLEN", regionId: 13 },
  { id: 216, name: "PENCAHUE", regionId: 7 },
  { id: 217, name: "PENCO", regionId: 8 },
  { id: 218, name: "PERALILLO", regionId: 6 },
  { id: 219, name: "PERQUENCO", regionId: 9 },
  { id: 220, name: "PETORCA", regionId: 5 },
  { id: 221, name: "PEUMO", regionId: 6 },
  { id: 222, name: "PICA", regionId: 1 },
  { id: 223, name: "PICHIDEGUA", regionId: 6 },
  { id: 224, name: "PICHILEMU", regionId: 6 },
  { id: 225, name: "PINTO", regionId: 16 },
  { id: 226, name: "PIRQUE", regionId: 13 },
  { id: 227, name: "PITRUFQUEN", regionId: 9 },
  { id: 228, name: "PLACILLA", regionId: 6 },
  { id: 229, name: "PORTEZUELO", regionId: 16 },
  { id: 230, name: "PORVENIR", regionId: 12 },
  { id: 231, name: "POZO ALMONTE", regionId: 1 },
  { id: 232, name: "PRIMAVERA", regionId: 12 },
  { id: 233, name: "PROVIDENCIA", regionId: 13 },
  { id: 234, name: "PUCHUNCAVI", regionId: 5 },
  { id: 235, name: "PUCON", regionId: 9 },
  { id: 236, name: "PUDAHUEL", regionId: 13 },
  { id: 237, name: "PUENTE ALTO", regionId: 13 },
  { id: 238, name: "PUERTO MONTT", regionId: 10 },
  { id: 239, name: "PUERTO OCTAY", regionId: 10 },
  { id: 240, name: "PUERTO VARAS", regionId: 10 },
  { id: 241, name: "PUMANQUE", regionId: 6 },
  { id: 242, name: "PUNITAQUI", regionId: 4 },
  { id: 243, name: "PUNTA ARENAS", regionId: 12 },
  { id: 244, name: "PUQUELDON", regionId: 10 },
  { id: 245, name: "PUREN", regionId: 9 },
  { id: 246, name: "PURRANQUE", regionId: 10 },
  { id: 247, name: "PUTAENDO", regionId: 5 },
  { id: 248, name: "PUTRE", regionId: 15 },
  { id: 249, name: "PUYEHUE", regionId: 10 },
  { id: 250, name: "QUEILEN", regionId: 10 },
  { id: 251, name: "QUELLÓN", regionId: 10 },
  { id: 252, name: "QUEMCHI", regionId: 10 },
  { id: 253, name: "QUILACO", regionId: 8 },
  { id: 254, name: "QUILICURA", regionId: 13 },
  { id: 255, name: "QUILLECO", regionId: 8 },
  { id: 256, name: "QUILLON", regionId: 16 },
  { id: 257, name: "QUILPUE", regionId: 5 },
  { id: 258, name: "QUINCHAO", regionId: 10 },
  { id: 259, name: "QUINTA DE TILCOCO", regionId: 6 },
  { id: 260, name: "QUINTA NORMAL", regionId: 13 },
  { id: 261, name: "QUINTERO", regionId: 5 },
  { id: 262, name: "QUIRIHUE", regionId: 16 },
  { id: 263, name: "RANCAGUA", regionId: 6 },
  { id: 264, name: "RANQUIL", regionId: 16 },
  { id: 265, name: "RAUCO", regionId: 7 },
  { id: 266, name: "RECOLETA", regionId: 13 },
  { id: 267, name: "RENAICO", regionId: 9 },
  { id: 268, name: "RENCA", regionId: 13 },
  { id: 269, name: "RENGO", regionId: 6 },
  { id: 270, name: "REQUINOA", regionId: 6 },
  { id: 271, name: "RETIRO", regionId: 7 },
  { id: 272, name: "RINCONADA", regionId: 5 },
  { id: 273, name: "RIO BUENO", regionId: 14 },
  { id: 274, name: "RIO CLARO", regionId: 7 },
  { id: 275, name: "RIO HURTADO", regionId: 4 },
  { id: 276, name: "RIO IBANEZ", regionId: 11 },
  { id: 277, name: "RIO NEGRO", regionId: 10 },
  { id: 278, name: "RIO VERDE", regionId: 12 },
  { id: 279, name: "ROMERAL", regionId: 7 },
  { id: 280, name: "SAAVEDRA", regionId: 9 },
  { id: 281, name: "SAGRADA FAMILIA", regionId: 7 },
  { id: 282, name: "SALAMANCA", regionId: 4 },
  { id: 283, name: "SAN ANTONIO", regionId: 5 },
  { id: 284, name: "SAN BERNARDO", regionId: 13 },
  { id: 285, name: "SAN CARLOS", regionId: 16 },
  { id: 286, name: "SAN CLEMENTE", regionId: 7 },
  { id: 287, name: "SAN ESTEBAN", regionId: 5 },
  { id: 288, name: "SAN FABIAN", regionId: 16 },
  { id: 289, name: "SAN FELIPE", regionId: 5 },
  { id: 290, name: "SAN FERNANDO", regionId: 6 },
  { id: 291, name: "SAN GREGORIO", regionId: 12 },
  { id: 292, name: "SAN IGNACIO", regionId: 16 },
  { id: 293, name: "SAN JAVIER", regionId: 7 },
  { id: 294, name: "SAN JOAQUIN", regionId: 13 },
  { id: 295, name: "SAN JOSE DE MAIPO", regionId: 13 },
  { id: 296, name: "SAN JUAN DE LA COSTA", regionId: 10 },
  { id: 297, name: "SAN MIGUEL", regionId: 13 },
  { id: 298, name: "SAN NICOLAS", regionId: 16 },
  { id: 299, name: "SAN PABLO", regionId: 10 },
  { id: 300, name: "SAN PEDRO", regionId: 13 },
  { id: 301, name: "SAN PEDRO DE ATACAMA", regionId: 2 },
  { id: 302, name: "SAN PEDRO DE LA PAZ", regionId: 8 },
  { id: 303, name: "SAN RAFAEL", regionId: 7 },
  { id: 304, name: "SAN RAMON", regionId: 13 },
  { id: 305, name: "SAN ROSENDO", regionId: 8 },
  { id: 306, name: "SAN VICENTE", regionId: 6 },
  { id: 307, name: "SANTA BARBARA", regionId: 8 },
  { id: 308, name: "SANTA CRUZ", regionId: 6 },
  { id: 309, name: "SANTA JUANA", regionId: 8 },
  { id: 310, name: "SANTA MARIA", regionId: 5 },
  { id: 311, name: "SANTIAGO", regionId: 13 },
  { id: 312, name: "SANTO DOMINGO", regionId: 5 },
  { id: 313, name: "SIERRA GORDA", regionId: 2 },
  { id: 314, name: "TALAGANTE", regionId: 13 },
  { id: 315, name: "TALCA", regionId: 7 },
  { id: 316, name: "TALCAHUANO", regionId: 8 },
  { id: 317, name: "TALTAL", regionId: 2 },
  { id: 318, name: "TEMUCO", regionId: 9 },
  { id: 319, name: "TENO", regionId: 7 },
  { id: 320, name: "TEODORO SCHMIDT", regionId: 9 },
  { id: 321, name: "TIERRA AMARILLA", regionId: 3 },
  { id: 322, name: "TILTIL", regionId: 13 },
  { id: 323, name: "TIMAUKEL", regionId: 12 },
  { id: 324, name: "TIRUA", regionId: 8 },
  { id: 325, name: "TOCOPILLA", regionId: 2 },
  { id: 326, name: "TOLTEN", regionId: 9 },
  { id: 327, name: "TOME", regionId: 8 },
  { id: 328, name: "TORRES DEL PAINE", regionId: 12 },
  { id: 329, name: "TORTEL", regionId: 11 },
  { id: 330, name: "TRAIGUEN", regionId: 9 },
  { id: 331, name: "TREHUACO", regionId: 16 },
  { id: 332, name: "TUCAPEL", regionId: 8 },
  { id: 333, name: "VALDIVIA", regionId: 14 },
  { id: 334, name: "VALLENAR", regionId: 3 },
  { id: 335, name: "VALPARAISO", regionId: 5 },
  { id: 336, name: "VICHUQUEN", regionId: 7 },
  { id: 337, name: "VICTORIA", regionId: 9 },
  { id: 338, name: "VICUNA", regionId: 4 },
  { id: 339, name: "VILCUN", regionId: 9 },
  { id: 340, name: "VILLA ALEGRE", regionId: 7 },
  { id: 341, name: "VILLA ALEMANA", regionId: 5 },
  { id: 342, name: "VILLARRICA", regionId: 9 },
  { id: 343, name: "VINA DEL MAR", regionId: 5 },
  { id: 344, name: "VITACURA", regionId: 13 },
  { id: 345, name: "YERBAS BUENAS", regionId: 7 },
  { id: 346, name: "YUMBEL", regionId: 8 },
  { id: 347, name: "YUNGAY", regionId: 16 },
  { id: 348, name: "ZAPALLAR", regionId: 5 },
];

/**
 * Regiones de Chile para agrupar comunas
 */
export const REGIONES_CHILE = {
  1: "Tarapacá",
  2: "Antofagasta",
  3: "Atacama",
  4: "Coquimbo",
  5: "Valparaíso",
  6: "O'Higgins",
  7: "Maule",
  8: "Biobío",
  9: "La Araucanía",
  10: "Los Lagos",
  11: "Aysén",
  12: "Magallanes",
  13: "Metropolitana",
  14: "Los Ríos",
  15: "Arica y Parinacota",
  16: "Ñuble",
};

/**
 * Lista de regiones como array para usar en selectores
 * Ordenadas de norte a sur según numeración oficial
 */
export const REGIONES_CHILE_ARRAY = [
  { id: 15, name: "Arica y Parinacota" },
  { id: 1, name: "Tarapacá" },
  { id: 2, name: "Antofagasta" },
  { id: 3, name: "Atacama" },
  { id: 4, name: "Coquimbo" },
  { id: 5, name: "Valparaíso" },
  { id: 13, name: "Metropolitana" },
  { id: 6, name: "O'Higgins" },
  { id: 7, name: "Maule" },
  { id: 16, name: "Ñuble" },
  { id: 8, name: "Biobío" },
  { id: 9, name: "La Araucanía" },
  { id: 14, name: "Los Ríos" },
  { id: 10, name: "Los Lagos" },
  { id: 11, name: "Aysén" },
  { id: 12, name: "Magallanes" },
];

/**
 * Obtiene el nombre de la comuna por ID
 * @param {number} comunaId - ID de la comuna
 * @returns {string} Nombre de la comuna o cadena vacía si no existe
 */
export const getComunaName = (comunaId) => {
  const comuna = COMUNAS_CHILE.find((c) => c.id === comunaId);
  return comuna ? comuna.name : "";
};

/**
 * Obtiene la región de una comuna por su ID
 * @param {number} comunaId - ID de la comuna
 * @returns {number|null} ID de la región o null si no existe
 */
export const getRegionIdByComuna = (comunaId) => {
  const comuna = COMUNAS_CHILE.find((c) => c.id === comunaId);
  return comuna ? comuna.regionId : null;
};

/**
 * Obtiene las comunas ordenadas alfabéticamente
 * @returns {Array} Lista de comunas ordenadas
 */
export const getComunasOrdenadas = () => {
  return [...COMUNAS_CHILE].sort((a, b) => a.name.localeCompare(b.name));
};

/**
 * Obtiene las comunas de una región específica
 * @param {number} regionId - ID de la región
 * @returns {Array} Lista de comunas de la región
 */
export const getComunasPorRegion = (regionId) => {
  return COMUNAS_CHILE.filter((c) => c.regionId === regionId).sort((a, b) =>
    a.name.localeCompare(b.name)
  );
};

export default COMUNAS_CHILE;
